

































import Vue from 'vue'

export default Vue.extend({
  name: 'DdModal',

  props: {
    /*
    * @description: Title of modal.
    */
    title: {
      type: String,
      default: '',
    },
    /*
    * @description: Subtitle of modal. Can pass in HTML as well.
    */
    subtitle: {
      type: String,
      default: '',
    },
    /*
    * @description: 'Small' (500px), 'Medium' (624px), 'Large' (800px), 'Grow' (70%)
    */
    desktopSizing: {
      type: String,
      default: 'medium',
    },
    /*
    * @description: If true, height is 800px instead of 600px
    */
    extendHeight: {
      type: Boolean,
      default: false,
    },
    /*
    * @description: Margin-top of modal.
    */
    top: {
      type: String,
      default: '5vh',
    },
    /*
    * @description: Dynamic props use for open/close modal
    */
    visible: {
      type: Boolean,
      default: true,
    },
    /*
    * @description: If false disabled "x" button and need implement attr beforeClose for wrapper
    */
    selfClose: {
      type: Boolean,
      default: true,
    },
    /*
    * @description: function wrapper for click on "X" button. Only work if selfClose equal false
    */
    beforeClose: {
      type: Function,
      default: () => false,
    },
  },

  computed: {
    width(): string {
      if (this.$screen.isMobile(this.$mq)) {
        return '70%'
      }

      if (this.desktopSizing === 'small') {
        return '500px'
      } else if (this.desktopSizing === 'medium') {
        return '624px'
      } else if (this.desktopSizing === 'large') {
        return '800px'
      } else if (this.desktopSizing === 'grow') {
        return '70%'
      }
    },
  },

  watch: {
    /**
     * Remove body scroll when modals
     */
    visible(value: boolean) {
      if (value === true) {
        this.$bodyScroll.disable()
      } else {
        this.$bodyScroll.enable()
        this.handleClose()
      }
    },
  },

  methods: {
    handleClose() {
      const body: HTMLElement = this.$el.querySelector('.el-dialog__body')
      if (body) {
        body.scrollTop = 0
      }

      this.$emit('handleClose', true)

      if (this.selfClose) {
        this.$emit('update:visible', false)
      } else {
        // @ts-ignore
        this.beforeClose()
      }
    },
  },
})
